module.exports = __webpack_public_path__ + "img/icon-facade.1d33e29e.svg";